// import Cookies from 'js-cookie'
import i18n from '../../locales'
import { languageMap } from '@/utils/maps'
import { PostLog } from '@/api/components/index'
import { Locale } from 'vant'
import { getWalletUserNotificationMessagePage } from '@/api/notify/notify'

const state = {
  language: localStorage.getItem('lang') || 'th',
  unReadNum: 0,
  isBluepay: process.env.VUE_APP_PLATFORM === 'bluepay'
}

const mutations = {
  SET_LANGUAGE: (state, language) => {
    state.language = language
    localStorage.setItem('lang', language)
  },
  SET_UNREADNUM: (state, unReadNum) => {
    state.unReadNum = unReadNum
  }
}

const actions = {
  setLanguage({ commit }, language) {
    if (!languageMap.has(language)) return
    commit('SET_LANGUAGE', language)
    const lang = languageMap.get(language)
    Locale.use(lang.key, lang.value)
    i18n.locale = language
  },
  submitLog({ commit }, params) {
    return new Promise((resolve, reject) => {
      PostLog(params)
        .then(res => {
          resolve(res)
        })
        .catch(e => {
          reject(e)
        })
    })
  },
  getWalletUserNotificationMessagePage({ commit }, params) {
    return new Promise((resolve, reject) => {
      params = { ...params, status: 1 }
      getWalletUserNotificationMessagePage(params)
        .then(res => {
          const data = res.data || []
          const total = data.total || 0
          commit('SET_UNREADNUM', total)
          resolve(res)
        })
        .catch(e => {
          reject(e)
        })
    })
  }
}

const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
